<div class="page-header-main">
  <div class="row align-items-center justify-content-between">
    <div class="col-md-auto col-sm-auto col">
      <div class="content-header">
        <h1>News</h1>
      </div>
    </div>
    <div class="col-md-auto col-sm-auto col-auto">
      <button (click)="openAddEditDialog()" class="btn blue-btn btn-sm">
        <i class="fas fa-plus"></i> Add News
      </button>
    </div>
  </div>
</div>

<div class="table-responsive">
  <table
    mat-table
    [dataSource]="dataSource"
    class="table grid_table table-bordered table-hover"
  >
    <!-- ACTION Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell class="table-column-100" *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let news" class="gap-2">
        <mat-icon
          class="interButtonIcons text-success"
          (click)="openAddEditDialog(news)"
          >edit</mat-icon
        >
        <mat-icon
          class="interButtonIcons text-danger"
          (click)="deleteNews(news)"
          >delete</mat-icon
        >
      </td>
    </ng-container>

    <!-- ID Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let news">{{ news.id }}</td>
    </ng-container>

    <!-- Title Column -->
    <ng-container matColumnDef="newsTitle">
      <th mat-header-cell class="table-column-400" *matHeaderCellDef>
        News Title
      </th>
      <td mat-cell *matCellDef="let news">{{ news.newsTitle }}</td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="newsDesc">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        News Description
      </th>
      <td mat-cell *matCellDef="let news">{{ news.newsDesc }}</td>
    </ng-container>

    <!-- Details Column -->
    <ng-container matColumnDef="newsDetails">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        News Details
      </th>
      <td mat-cell *matCellDef="let news">{{ news.newsDetails }}</td>
    </ng-container>

    <!-- Created By Column -->
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Created By
      </th>
      <td mat-cell *matCellDef="let news">{{ news.createdBy }}</td>
    </ng-container>

    <!-- Created Date Column -->
    <ng-container matColumnDef="createdDate">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Created Date
      </th>
      <td mat-cell *matCellDef="let news">
        {{ news.createdDate | date: "dd-MM-yyyy hh:mm a" }}
      </td>
    </ng-container>

    <!-- Updated By Column -->
    <ng-container matColumnDef="updatedBy">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Updated By
      </th>
      <td mat-cell *matCellDef="let news">{{ news.updatedBy }}</td>
    </ng-container>

    <!-- Updated Date Column -->
    <ng-container matColumnDef="updatedDate">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Updated Date
      </th>
      <td mat-cell *matCellDef="let news">
        {{ news.updatedDate | date: "dd-MM-yyyy hh:mm a" }}
      </td>
    </ng-container>

    <!-- Approved By Column -->
    <ng-container matColumnDef="approvedBy">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Approved By
      </th>
      <td mat-cell *matCellDef="let news">{{ news.approvedBy }}</td>
    </ng-container>

    <!-- Approved Date Column -->
    <ng-container matColumnDef="approvedDate">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Approved Date
      </th>
      <td mat-cell *matCellDef="let news">
        {{ news.approvedDate | date: "dd-MM-yyyy hh:mm a" }}
      </td>
    </ng-container>

    <!-- Approved Status Column -->
    <ng-container matColumnDef="approvedStatus">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Approved Status
      </th>
      <td mat-cell *matCellDef="let news">{{ news.approvedStatus }}</td>
    </ng-container>

    <!-- Date Actual Column -->
    <ng-container matColumnDef="dateActual">
      <th mat-header-cell class="table-column-200" *matHeaderCellDef>
        Date Actual
      </th>
      <td mat-cell *matCellDef="let news">
        {{ news.dateActual | date: "dd-MM-yyyy hh:mm a" }}
      </td>
    </ng-container>

    <!-- Paginator Footer Column -->
    <ng-container matColumnDef="paginator">
      <td
        mat-footer-cell
        *matFooterCellDef
        [attr.colspan]="displayedColumns.length"
      >
        <mat-paginator
          [length]="totalCount"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 20, 50]"
          showFirstLastButtons
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </td>
    </ng-container>

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <!-- Data Rows -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <!-- Footer Row with Paginator -->
    <tr mat-footer-row *matFooterRowDef="['paginator']"></tr>

    <!-- No Data Row -->
    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell"
        colspan="12"
        style="text-align: center; padding: 2rem"
      >
        No news found.
      </td>
    </tr>
  </table>
</div>
